import { CSSProperties } from 'react';

import { Palette } from '@mui/material';

import { IconButtonVariantColor } from '../types';

export const mapColorForTextVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.primary.main;
    case 'info':
      return palette.info.contrastText;
    case 'error':
      return palette.error.main;
    default:
      return palette.secondary.contrastText;
  }
};

export const mapHoverColorForTextVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.primary.dark;
    case 'info':
      return palette.info.contrastText;
    case 'error':
      return palette.error.dark;
    default:
      return palette.secondary.contrastText;
  }
};

export const mapHoverBackgroundForTextVariant = (
  palette: Palette,
  color?: IconButtonVariantColor
): CSSProperties['backgroundColor'] => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[25];
    case 'text':
      return palette.grey[200];
    default:
      return 'transparent';
  }
};

export const mapFocusColorForTextVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[700];
    case 'info':
      return palette.info.contrastText;
    case 'error':
      return palette.error.dark;
    case 'text':
      return palette.text.primary;
    default:
      return palette.secondary.contrastText;
  }
};

export const mapFocusBackgroundForTextVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  if (color === 'text') {
    return palette.grey[300];
  }
  return 'transparent';
};

export const mapActiveColorForTextVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[900];
    case 'text':
      return palette.primary.main;
    default:
      return mapColorForTextVariant(palette, color);
  }
};

export const mapActiveBackgroundForTextVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[100];
    case 'info':
      return palette.info.contrastText;
    case 'error':
      return palette.error.dark;
    case 'text':
      return palette.extendedPrimary[50];
    default:
      return palette.grey[300];
  }
};

export const mapColorForOutlinedVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.primary.main;
    case 'text':
      return palette.grey[700];
    default:
      return mapColorForTextVariant(palette, color);
  }
};

export const mapBackgroundColorForOutlinedHoverVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[50];
    case 'info':
      return palette.info.contrastText;
    case 'light':
      return palette.grey[50];
    case 'error':
      return palette.error.dark;
    default:
      return palette.grey[300];
  }
};

export const mapBackgroundColorForOutlinedFocusVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[100];
    case 'info':
      return palette.info.contrastText;
    case 'light':
      return palette.grey[100];
    case 'error':
      return palette.error.dark;
    default:
      return palette.secondary.contrastText;
  }
};

export const mapBorderColorForOutlinedFocusVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[800];
    case 'info':
      return palette.grey[400];
    default:
      return palette.secondary.contrastText;
  }
};

export const mapBackgroundColorForOutlinedActiveVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[200];
    case 'info':
      return palette.info.contrastText;
    case 'light':
      return palette.grey[200];
    case 'error':
      return palette.error.dark;
    default:
      return palette.grey[300];
  }
};

export const mapBorderColorForOutlinedActiveVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.extendedPrimary[900];
    case 'info':
      return palette.info.contrastText;
    case 'light':
      return palette.grey[500];
    case 'error':
      return palette.error.dark;
    default:
      return palette.grey[300];
  }
};

export const mapBorderColorForOutlinedVariant = (palette: Palette, color?: IconButtonVariantColor) => {
  switch (color) {
    case 'primary':
      return palette.primary.main;
    case 'info':
      return palette.info.contrastText;
    case 'light':
      return palette.grey[300];
    case 'error':
      return palette.error.main;
    default:
      return palette.secondary.contrastText;
  }
};
